export class FilterTypes {
    public static REQUIRED: number = 0;
    public static OPTIONAL: number = 1;
}
